import { http } from "api/http";

interface IUpdateData {
  data: {};
}

const getInvoicePreference = () => {
  return http.get(`/organization-preferences/getInvoicePreferences`, {});
};

const insertOrganizationpreference = ({ data }: IUpdateData) => {
  return http.post(`/organization-preferences/update`, data);
};

const insertHolidaypreference = ({ data }: IUpdateData) => {
  return http.post("/organization-preferences/updateholiday", data);
};

const updateWeekendData = ({ data }: IUpdateData) => {
  return http.post("/organization-preferences/updateWeekendData", data);
};

const deleteHoliday = (data) => {
  return http.patch("/organization-preferences/deleteHoliday", data);
};

const getTaskPreferences = ({ queryKey }: any) => {
  return http.get(`/organization-preferences/getTaskPreferences/${queryKey[1]}`, {});
};

const updateTaskPreferences = ({ data }) => {
  return http.post("/organization-preferences/update-task-preferences", data);
};
const updateApprovalPreferences = ({ data }) => {
  return http.post("/organization-preferences/update-approval-preferences", data);
};

const updateGeoFencePreferences = ({ data }) => {
  return http.post("/organization-preferences/update-geo-fence-preferences", data);
};

const getClientAction = () => {
  return http.get("/organization-preferences/getClientAction");
};

const getClientPreferences = () => {
  return http.get("/organization-preferences/getClientPreferences");
};

const updateClientPreferences = ({ data }) => {
  return http.put("/organization-preferences/getClientPreferences", data);
};

const getClientPrefix = () => {
  return http.get("/organization-preferences/clientPrefix");
};

const getClientFormData = () => {
  return http.get("/organization-preferences/client-form-data");
};

const addClientPrefix = ({ data }) => {
  return http.post("/organization-preferences/addClientPrefix", data);
};

const getClientPrefixId = () => {
  return http.get("/organization-preferences/clientPrefixId");
};

const getClientGroupPrefixId = () => {
  return http.get("/organization-preferences/clientGroupPrefixId");
};

const getPageDefaultLimit = () => {
  return http.get("/organization-preferences/page-limit");
};

const udatePageLimit = (data) => {

  return http.patch("/organization-preferences/update-limit", data)
}



export {
  getInvoicePreference,
  insertOrganizationpreference,
  insertHolidaypreference,
  updateWeekendData,
  deleteHoliday,
  getClientAction,
  getClientPreferences,
  updateClientPreferences,
  getClientPrefix,
  getClientFormData,
  addClientPrefix,
  getClientPrefixId,
  updateTaskPreferences,
  getTaskPreferences,
  getClientGroupPrefixId,
  updateApprovalPreferences,
  updateGeoFencePreferences,
  getPageDefaultLimit,
  udatePageLimit
};
